import React, { useEffect, useMemo, useRef, useState } from "react";

import Header from "../master/SideBar";
import Nav from "../master/NavBar";

import {
  UpdateTimetable,
  TimetableList,
  ScheduleList,
  EnrollTimetable,
} from "../../api/TimeTableService";

import { formatTime, SweetAlertShow } from "../master/Master";
import { getBatchNCourseList } from "../../api/BatchService";
import { StaffList } from "../../api/Staff";

import Master from "./Master";
import { useNavigate } from "react-router-dom";
import usePrivateLink from "../config/usePrivateLink";

const ACCENTS = [
  "#7367f0",
  "#00bad1",
  "#28c76f",
  "#ff9f43",
  "#ea5455",
  "#8592a3",
];
const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri"];

const styles = `
.tt-page .tt-hero-icon {
  width: 46px; height: 46px; border-radius: 12px;
  display: inline-flex; align-items: center; justify-content: center;
  background: rgba(var(--bs-primary-rgb), .12); color: var(--bs-primary); font-size: 22px;
}
.tt-page .tt-stat {
  display: inline-flex; align-items: center; gap: .5rem;
  padding: .4rem .85rem; border-radius: 999px; font-size: .8125rem;
  background: rgba(var(--bs-primary-rgb), .08); color: var(--bs-body-color);
}
.tt-page .tt-stat i { color: var(--bs-primary); }
.tt-page .tt-schedule {
  border: 1px solid var(--bs-border-color, #e6e6e8);
  border-left: 4px solid var(--tt-accent, var(--bs-primary));
  border-radius: .6rem; overflow: hidden; background: var(--bs-body-bg, #fff);
  transition: box-shadow .15s ease;
}
.tt-page .tt-schedule:hover { box-shadow: 0 3px 14px rgba(0,0,0,.06); }
.tt-page .tt-schedule-header {
  cursor: pointer; user-select: none; padding: .9rem 1.1rem;
  display: flex; align-items: center; justify-content: space-between; gap: 1rem;
}
.tt-page .tt-schedule-header:hover { background: rgba(var(--bs-primary-rgb), .04); }
.tt-page .tt-step {
  width: 34px; height: 34px; border-radius: 50%; color: #fff; font-weight: 600;
  display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.tt-page .tt-schedule-body { padding: 1rem 1.1rem 1.1rem; border-top: 1px dashed var(--bs-border-color, #e6e6e8); }
.tt-page .tt-entry {
  position: relative; border: 1px solid var(--bs-border-color, #e6e6e8); border-radius: .55rem;
  padding: .85rem .9rem; margin-bottom: .75rem; background: var(--bs-body-bg, #fff);
  transition: border-color .15s ease, box-shadow .15s ease, background .15s ease;
}
.tt-page .tt-entry:hover { box-shadow: 0 2px 10px rgba(0,0,0,.06); }
.tt-page .tt-entry.selectable { cursor: pointer; }
.tt-page .tt-entry.selected {
  border-color: var(--bs-primary); background: rgba(var(--bs-primary-rgb), .06);
  box-shadow: 0 0 0 1px var(--bs-primary) inset;
}
.tt-page .tt-entry-no {
  width: 26px; height: 26px; border-radius: 8px; font-size: .75rem; font-weight: 600;
  display: inline-flex; align-items: center; justify-content: center;
  background: rgba(var(--bs-primary-rgb), .12); color: var(--bs-primary);
}
.tt-page .tt-label { font-size: .72rem; font-weight: 600; letter-spacing: .03em; text-transform: uppercase; color: var(--bs-secondary-color, #8592a3); margin-bottom: .25rem; display: block; }
.tt-page .tt-day { min-width: 46px; padding-left: .55rem; padding-right: .55rem; border-radius: 999px; }
.tt-page .tt-day-chip {
  display: inline-block; padding: .15rem .6rem; border-radius: 999px; font-size: .75rem;
  background: rgba(var(--bs-primary-rgb), .12); color: var(--bs-primary); font-weight: 500;
}
.tt-page .tt-link-btn { background: none; border: 0; padding: 0; font-size: .75rem; color: var(--bs-primary); }
.tt-page .tt-link-btn:hover { text-decoration: underline; }
.tt-page .tt-link-btn:disabled { color: var(--bs-secondary-color, #8592a3); text-decoration: none; }
.tt-page .tt-empty {
  text-align: center; padding: 1.75rem 1rem; border: 1px dashed var(--bs-border-color, #d9dee3);
  border-radius: .55rem; color: var(--bs-secondary-color, #8592a3); margin-bottom: .75rem;
}
.tt-page .tt-actionbar {
  position: sticky; bottom: 0; z-index: 6; margin-top: 1rem; padding: .85rem 1rem;
  display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap;
  background: var(--bs-body-bg, #fff); border: 1px solid var(--bs-border-color, #e6e6e8);
  border-radius: .6rem; box-shadow: 0 -6px 18px rgba(0,0,0,.06);
}
.tt-page .tt-landing-icon {
  width: 84px; height: 84px; border-radius: 50%; margin: 0 auto;
  display: flex; align-items: center; justify-content: center; font-size: 38px;
  background: rgba(var(--bs-primary-rgb), .1); color: var(--bs-primary);
}
.tt-page .tt-skeleton { height: 64px; border-radius: .6rem; margin-bottom: 1rem; }
`;

export default function TimetableManage() {
  const navigate = useNavigate();
  const uidRef = useRef(0);
  const hasAccess = usePrivateLink();


  const [loading, setLoading] = useState(false);
  const [loadingEntries, setLoadingEntries] = useState(false);
  const [enrollLoading, setEnrollLoading] = useState(false);
  const [batches, setBatches] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [batchId, setBatchId] = useState("");

  // All data is keyed by schedule id
  const [entriesBySchedule, setEntriesBySchedule] = useState({});
  const [deletedBySchedule, setDeletedBySchedule] = useState({});
  const [warnings, setWarnings] = useState({});
  const [collapsed, setCollapsed] = useState({});

  const [isEnrollMode, setIsEnrollMode] = useState(false);
  const [newBatchId, setNewBatchId] = useState("");
  // { [scheduleId]: [timetableIds] }
  const [selectedEnroll, setSelectedEnroll] = useState({});

  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const selectedBatch = useMemo(
    () => batches.find((batch) => String(batch.id) === String(batchId)),
    [batches, batchId],
  );

  const selectedNewBatch = useMemo(
    () => batches.find((batch) => String(batch.id) === String(newBatchId)),
    [batches, newBatchId],
  );

  const parseDays = (value) => {
    if (Array.isArray(value)) return value;
    if (!value) return [];
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const createEmptyEntry = () => {
    uidRef.current += 1;
    return {
      uid: `new-${uidRef.current}`,
      id: null,
      subject_id: "",
      teacher_id: "",
      days: [],
    };
  };

  const isEntryBlank = (entry) =>
    !entry.subject_id &&
    !entry.teacher_id &&
    (!entry.days || entry.days.length === 0);

  const clearWarning = (scheduleId) =>
    setWarnings((prev) =>
      prev[scheduleId] ? { ...prev, [scheduleId]: "" } : prev,
    );

  const getSubjectName = (id) => {
    const subject = (selectedBatch?.course?.subjects_data || []).find(
      (item) => String(item.id) === String(id),
    );
    if (!subject) return id ? `Subject ${id}` : "-";
    return subject.name || subject.subject_name || `Subject ${subject.id}`;
  };

  const getStaffName = (id) => {
    const staff = staffs.find((item) => String(item.id) === String(id));
    return staff?.name || (id ? `Teacher ${id}` : "-");
  };

  /* ---------------- entry helpers (per schedule) ---------------- */

  const addEntry = (scheduleId) => {
    clearWarning(scheduleId);
    setEntriesBySchedule((prev) => ({
      ...prev,
      [scheduleId]: [...(prev[scheduleId] || []), createEmptyEntry()],
    }));
  };

  const updateEntry = (scheduleId, index, field, value) => {
    clearWarning(scheduleId);
    setEntriesBySchedule((prev) => ({
      ...prev,
      [scheduleId]: (prev[scheduleId] || []).map((entry, i) =>
        i === index ? { ...entry, [field]: value } : entry,
      ),
    }));
  };

  const toggleEntryDay = (scheduleId, index, day) => {
    clearWarning(scheduleId);
    setEntriesBySchedule((prev) => ({
      ...prev,
      [scheduleId]: (prev[scheduleId] || []).map((entry, i) => {
        if (i !== index) return entry;
        const currentDays = entry.days || [];
        const updatedDays = currentDays.includes(day)
          ? currentDays.filter((item) => item !== day)
          : [...currentDays, day];
        return { ...entry, days: updatedDays };
      }),
    }));
  };

  const removeEntry = (scheduleId, index) => {
    const entry = (entriesBySchedule[scheduleId] || [])[index];

    if (entry?.id) {
      setDeletedBySchedule((prev) => {
        const list = prev[scheduleId] || [];
        if (list.includes(entry.id)) return prev;
        return { ...prev, [scheduleId]: [...list, entry.id] };
      });
    }

    setEntriesBySchedule((prev) => ({
      ...prev,
      [scheduleId]: (prev[scheduleId] || []).filter((_, i) => i !== index),
    }));
  };

  // Copy rows from the previous schedule (as new rows) to save typing
  const copyFromPrevious = (scheduleIndex) => {
    if (scheduleIndex === 0) return;
    const current = schedules[scheduleIndex];
    const previous = schedules[scheduleIndex - 1];
    const source = (entriesBySchedule[previous.id] || []).filter(
      (e) => !isEntryBlank(e),
    );

    if (source.length === 0) {
      SweetAlertShow(
        "info",
        "Warning",
        `${previous.title} has no entries to copy.`,
      );
      return;
    }

    clearWarning(current.id);
    setEntriesBySchedule((prev) => {
      const existing = (prev[current.id] || []).filter((e) => !isEntryBlank(e));
      const copied = source.map((e) => ({
        ...createEmptyEntry(),
        subject_id: e.subject_id,
        teacher_id: e.teacher_id,
        days: [...(e.days || [])],
      }));
      return { ...prev, [current.id]: [...existing, ...copied] };
    });
  };

  /* ---------------- data loading ---------------- */

  const getBatchList = async () => {
    try {
      const response = await getBatchNCourseList();
      setBatches(response?.data?.status ? response?.data?.data || [] : []);
    } catch (error) {
      setBatches([]);
      console.error("Batch List Error:", error);
    }
  };

  const getScheduleList = async () => {
    try {
      const response = await ScheduleList();
      setSchedules(response?.data?.status ? response?.data?.data || [] : []);
    } catch (error) {
      setSchedules([]);
      console.error("Schedule List Error:", error);
    }
  };

  const getStaffList = async () => {
    try {
      const response = await StaffList();
      if (response?.data?.status) {
        setStaffs(
          Array.isArray(response?.data?.data) ? response.data.data : [],
        );
      } else {
        setStaffs([]);
      }
    } catch (error) {
      setStaffs([]);
      console.error("Staff List Error:", error);
    }
  };

  useEffect(() => {
    getBatchList();
    getScheduleList();
    getStaffList();
  }, []);

  // Loads the timetable of every schedule for the selected batch
  const loadTimetable = async (isCancelled = () => false) => {
    if (!batchId || schedules.length === 0) return;

    try {
      setLoadingEntries(true);
      setDeletedBySchedule({});
      setSelectedEnroll({});
      setWarnings({});

      const results = await Promise.all(
        schedules.map(async (schedule) => {
          try {
            const url = `&batch_id=${batchId}&schedule_id=${schedule.id}`;
            const response = await TimetableList(url);
            const rows = response?.data?.status
              ? response?.data?.data || []
              : [];

            const formatted = rows.map((item) => ({
              uid: `db-${item.id}`,
              id: item.id,
              subject_id: String(item.subject_id || ""),
              teacher_id: String(item.teacher_id || ""),
              days: parseDays(item.day),
            }));

            return [
              schedule.id,
              formatted.length > 0 ? formatted : [createEmptyEntry()],
            ];
          } catch (error) {
            console.error(
              `Timetable load error (schedule ${schedule.id}):`,
              error,
            );
            return [schedule.id, [createEmptyEntry()]];
          }
        }),
      );

      if (isCancelled()) return;
      setEntriesBySchedule(Object.fromEntries(results));
    } finally {
      if (!isCancelled()) setLoadingEntries(false);
    }
  };

  useEffect(() => {
    let cancelled = false;

    if (batchId && schedules.length > 0) {
      loadTimetable(() => cancelled);
    } else {
      setEntriesBySchedule({});
      setDeletedBySchedule({});
      setSelectedEnroll({});
    }

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [batchId, schedules]);

  /* ---------------- enroll mode ---------------- */

  const handleEnrollMode = () => {
    if (!batchId) {
      SweetAlertShow("info", "Warning", "Please select a batch first.");
      return;
    }

    setIsEnrollMode((prev) => {
      const nextMode = !prev;
      if (!nextMode) {
        setSelectedEnroll({});
        setNewBatchId("");
      }
      return nextMode;
    });
  };

  const totalSelected = useMemo(
    () =>
      Object.values(selectedEnroll).reduce((sum, ids) => sum + ids.length, 0),
    [selectedEnroll],
  );

  const allSavedEntries = useMemo(() => {
    const result = [];
    schedules.forEach((schedule) => {
      (entriesBySchedule[schedule.id] || []).forEach((entry) => {
        if (entry.id) result.push({ scheduleId: schedule.id, id: entry.id });
      });
    });
    return result;
  }, [schedules, entriesBySchedule]);

  const toggleEnrollEntry = (scheduleId, id) => {
    if (!id) return;
    setSelectedEnroll((prev) => {
      const list = prev[scheduleId] || [];
      const next = list.includes(id)
        ? list.filter((item) => item !== id)
        : [...list, id];
      return { ...prev, [scheduleId]: next };
    });
  };

  // Select / unselect every saved entry of one schedule
  const toggleScheduleEnroll = (scheduleId) => {
    const savedIds = (entriesBySchedule[scheduleId] || [])
      .filter((entry) => entry.id)
      .map((entry) => entry.id);

    if (savedIds.length === 0) return;

    setSelectedEnroll((prev) => {
      const current = prev[scheduleId] || [];
      const allSelected = savedIds.every((id) => current.includes(id));
      return { ...prev, [scheduleId]: allSelected ? [] : savedIds };
    });
  };

  const handleSelectAllEnroll = () => {
    if (allSavedEntries.length === 0) return;

    if (totalSelected === allSavedEntries.length) {
      setSelectedEnroll({});
      return;
    }

    const next = {};
    allSavedEntries.forEach(({ scheduleId, id }) => {
      next[scheduleId] = [...(next[scheduleId] || []), id];
    });
    setSelectedEnroll(next);
  };

  const handleEnroll = async () => {
    if (!newBatchId) {
      SweetAlertShow("info", "Warning", "Please select the target batch.");
      return;
    }

    if (String(newBatchId) === String(batchId)) {
      SweetAlertShow(
        "info",
        "Warning",
        "Target batch cannot be the same as source batch.",
      );
      return;
    }

    const scheduleIds = Object.keys(selectedEnroll).filter(
      (sid) => selectedEnroll[sid]?.length > 0,
    );

    if (scheduleIds.length === 0) {
      SweetAlertShow(
        "info",
        "Warning",
        "Please select at least one subject / teacher entry to enroll.",
      );
      return;
    }

    try {
      setEnrollLoading(true);

      const failures = [];

      for (const sid of scheduleIds) {
        try {
          const payload = {
            new_batch_id: Number(newBatchId),
            schedule_id: Number(sid),
            batch_id: Number(batchId),
            source_timetable_ids: selectedEnroll[sid].map((id) => Number(id)),
          };

          const response = await EnrollTimetable(payload);

          if (!response?.data?.status) {
            failures.push(
              response?.data?.message || `Unable to enroll schedule ${sid}.`,
            );
          }
        } catch (error) {
          failures.push(
            error?.response?.data?.message ||
            error?.message ||
            `Schedule ${sid} failed.`,
          );
        }
      }

      if (failures.length === 0) {
        SweetAlertShow(
          "success",
          "Success",
          "Timetable enrolled successfully.",
        );
        setSelectedEnroll({});
        setNewBatchId("");
        setIsEnrollMode(false);
        navigate("/timetable");
      } else {
        SweetAlertShow("info", "Warning", failures.join("\n"));
      }
    } finally {
      setEnrollLoading(false);
    }
  };

  /* ---------------- validate + save ---------------- */

  // Returns { valid, payloads } — blank rows are ignored, partial rows are errors
  const validateAll = () => {
    const newWarnings = {};
    const payloads = [];
    let firstInvalidScheduleId = null;

    schedules.forEach((schedule) => {
      const sid = schedule.id;
      const entries = entriesBySchedule[sid] || [];
      const deleted = deletedBySchedule[sid] || [];

      const filled = [];
      let error = "";

      entries.forEach((entry, i) => {
        if (error) return;

        // Untouched new row -> skip silently
        if (!entry.id && isEntryBlank(entry)) return;

        if (!entry.subject_id) {
          error = `Row ${i + 1}: Please select a subject.`;
        } else if (!entry.teacher_id) {
          error = `Row ${i + 1}: Please select a teacher.`;
        } else if (!entry.days || entry.days.length === 0) {
          error = `Row ${i + 1}: Please select at least one day.`;
        } else {
          filled.push(entry);
        }
      });

      if (error) {
        newWarnings[sid] = error;
        if (firstInvalidScheduleId === null) firstInvalidScheduleId = sid;
        return;
      }

      if (filled.length > 0 || deleted.length > 0) {
        payloads.push({ schedule, entries: filled, deleted });
      }
    });

    setWarnings(newWarnings);

    if (firstInvalidScheduleId !== null) {
      setCollapsed((prev) => ({ ...prev, [firstInvalidScheduleId]: false }));
      setTimeout(() => {
        document
          .getElementById(`schedule-card-${firstInvalidScheduleId}`)
          ?.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 50);
      return { valid: false, payloads: [] };
    }

    if (payloads.length === 0) {
      SweetAlertShow(
        "info",
        "Warning",
        "Please add at least one subject and teacher in any schedule.",
      );
      return { valid: false, payloads: [] };
    }

    return { valid: true, payloads };
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (isEnrollMode) return;

    if (!batchId) {
      SweetAlertShow("info", "Warning", "Please select a batch.");
      return;
    }

    const { valid, payloads } = validateAll();
    if (!valid) return;

    try {
      setLoading(true);

      const failures = [];

      for (const { schedule, entries, deleted } of payloads) {
        try {
          const formData = new FormData();

          formData.append("batch_id", batchId);
          formData.append("schedule_id", schedule.id);

          entries.forEach((entry, index) => {
            if (entry.id) {
              formData.append(`entries[${index}][id]`, entry.id);
            }

            formData.append(`entries[${index}][subject_id]`, entry.subject_id);
            formData.append(`entries[${index}][teacher_id]`, entry.teacher_id);

            entry.days.forEach((day) => {
              formData.append(`entries[${index}][days][]`, day);
            });
          });

          deleted.forEach((id) => {
            formData.append("deleted_ids[]", id);
          });

          const response = await UpdateTimetable(formData);

          if (!response?.data?.status) {
            failures.push(
              `${schedule.title}: ${response?.data?.message || "Unable to save."}`,
            );
          }
        } catch (error) {
          failures.push(
            `${schedule.title}: ${error?.response?.data?.message || error?.message || "Something went wrong."}`,
          );
        }
      }

      if (failures.length === 0) {
        SweetAlertShow("success", "Success", "Time table saved successfully.");
        setDeletedBySchedule({});
        navigate("/timetable");
      } else {
        SweetAlertShow("info", "Warning", failures.join("\n"));
        // Reload so saved schedules show their new ids and failed ones stay visible
        loadTimetable();
      }
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- render helpers ---------------- */

  const filledCount = (scheduleId) =>
    (entriesBySchedule[scheduleId] || []).filter(
      (entry) => !isEntryBlank(entry),
    ).length;

  const totalEntries = schedules.reduce((sum, s) => sum + filledCount(s.id), 0);
  const filledSchedules = schedules.filter((s) => filledCount(s.id) > 0).length;

  const collapseAll = () =>
    setCollapsed(Object.fromEntries(schedules.map((s) => [s.id, true])));
  const expandAll = () => setCollapsed({});

  const enrollHint = !newBatchId
    ? "Choose a target batch to continue"
    : totalSelected === 0
      ? "Tick at least one entry to enroll"
      : `${totalSelected} ${totalSelected === 1 ? "entry" : "entries"} will be enrolled to ${selectedNewBatch?.title || "target batch"}`;

  /* ---------------- render ---------------- */

  return (
    <div className="layout-wrapper layout-content-navbar">
      <style>{styles}</style>

      <div className="layout-container">
        <Header />

        <div className="layout-page">
          <Nav />

          <div className="content-wrapper">
            <div className="container-fluid mt-2 tt-page">
              <div className="row">
                <Master />

                <div className="col-md-12">
                  <div className="card mb-4">
                    {/* ---------- Page header ---------- */}
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                        <div className="d-flex align-items-center gap-3">
                          <span className="tt-hero-icon">
                            <i className="ri-calendar-line"></i>
                          </span>
                          <div>
                            <h5 className="mb-0 text-primary">
                              Time Table Management
                            </h5>
                            <small className="text-muted">
                              {isEnrollMode
                                ? "Pick entries from any schedule and enroll them into another batch."
                                : "Choose a batch, then set subject, teacher and days for each schedule."}
                            </small>
                          </div>
                        </div>
                        {hasAccess("/timetable/enroll") && (

                          <button
                            type="button"
                            className={
                              isEnrollMode
                                ? "btn btn-danger"
                                : "btn btn-outline-primary"
                            }
                            onClick={handleEnrollMode}
                          >
                            <i
                              className={
                                isEnrollMode
                                  ? "ri-close-circle-line me-2"
                                  : "ri-login-box-line me-2"
                              }
                            />
                            {isEnrollMode ? "Cancel Enroll" : "Enroll Timetable"}
                          </button>
                        )}
                      </div>
                    </div>

                    <div className="card-body">
                      {/* ---------- Batch selectors ---------- */}
                      <div className="row g-3 align-items-center mb-3">
                        <div className="col-lg-4 col-md-6">
                          <div className="form-floating form-floating-outline">
                            <select
                              className="form-select"
                              value={batchId}
                              disabled={isEnrollMode}
                              onChange={(e) => setBatchId(e.target.value)}
                            >
                              <option value="">Select Batch</option>
                              {batches.map((batch) => (
                                <option key={batch.id} value={batch.id}>
                                  {batch.title}
                                </option>
                              ))}
                            </select>
                            <label>
                              {isEnrollMode ? "Source Batch" : "Select Batch"}
                            </label>
                          </div>
                        </div>

                        {isEnrollMode && batchId && (
                          <>
                            <div className="col-lg-1 d-none d-lg-flex justify-content-center">
                              <i className="ri-arrow-right-line fs-4 text-primary"></i>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  value={newBatchId}
                                  onChange={(e) =>
                                    setNewBatchId(e.target.value)
                                  }
                                >
                                  <option value="">Select Target Batch</option>
                                  {batches
                                    .filter(
                                      (batch) =>
                                        String(batch.id) !== String(batchId),
                                    )
                                    .map((batch) => (
                                      <option key={batch.id} value={batch.id}>
                                        {batch.title}
                                      </option>
                                    ))}
                                </select>
                                <label>Enroll To Batch</label>
                              </div>
                            </div>
                          </>
                        )}

                        {batchId && !isEnrollMode && schedules.length > 0 && (
                          <div className="col-lg-8 col-md-6 d-flex justify-content-md-end gap-2">
                            <button
                              type="button"
                              className="btn btn-sm btn-label-secondary"
                              onClick={expandAll}
                            >
                              <i className="ri-expand-up-down-line me-1"></i>
                              Expand all
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-label-secondary"
                              onClick={collapseAll}
                            >
                              <i className="ri-contract-up-down-line me-1"></i>
                              Collapse all
                            </button>
                          </div>
                        )}
                      </div>

                      {/* ---------- Summary chips ---------- */}
                      {batchId && !loadingEntries && schedules.length > 0 && (
                        <div className="d-flex flex-wrap gap-2 mb-4">
                          <span className="tt-stat">
                            <i className="ri-stack-line"></i>
                            {selectedBatch?.title}
                          </span>
                          <span className="tt-stat">
                            <i className="ri-history-line"></i>
                            {filledSchedules} of {schedules.length} schedules
                            filled
                          </span>
                          <span className="tt-stat">
                            <i className="ri-book-open-line"></i>
                            {totalEntries}{" "}
                            {totalEntries === 1 ? "entry" : "entries"}
                          </span>
                        </div>
                      )}

                      {/* ---------- Enroll helper ---------- */}
                      {isEnrollMode && batchId && (
                        <div className="alert alert-primary d-flex align-items-start gap-3 mb-4">
                          <i className="ri-information-line fs-5"></i>
                          <div>
                            <div className="fw-semibold mb-1">
                              How enrolling works
                            </div>
                            <div className="small">
                              1. Choose the target batch &nbsp;→&nbsp; 2. Tick
                              the saved entries you want to copy &nbsp;→&nbsp;
                              3. Click “Enroll Selected”. Entries stay in their
                              same schedules.
                            </div>
                            {selectedNewBatch && (
                              <div className="small mt-2">
                                <strong>{selectedBatch?.title}</strong>
                                <i className="ri-arrow-right-line mx-2"></i>
                                <strong>{selectedNewBatch?.title}</strong>
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      {batchId && (
                        <form onSubmit={handleSave}>
                          {loadingEntries ? (
                            <div className="placeholder-glow">
                              {[1, 2, 3].map((n) => (
                                <span
                                  key={n}
                                  className="placeholder col-12 tt-skeleton d-block"
                                />
                              ))}
                            </div>
                          ) : schedules.length === 0 ? (
                            <div className="tt-empty">
                              <i className="ri-time-line fs-1 d-block mb-2"></i>
                              No schedules found. Please create schedules first.
                            </div>
                          ) : (
                            <>
                              {isEnrollMode && (
                                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                                  <div className="fw-semibold">
                                    Select entries to enroll
                                    <span className="badge bg-primary ms-2">
                                      {totalSelected} selected
                                    </span>
                                  </div>

                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={handleSelectAllEnroll}
                                    disabled={allSavedEntries.length === 0}
                                  >
                                    <i className="ri-checkbox-multiple-line me-1"></i>
                                    {allSavedEntries.length > 0 &&
                                      totalSelected === allSavedEntries.length
                                      ? "Unselect all"
                                      : "Select all"}
                                  </button>
                                </div>
                              )}

                              {isEnrollMode && allSavedEntries.length === 0 && (
                                <div className="alert alert-warning mb-3">
                                  <i className="ri-alert-line me-2"></i>
                                  No saved entries found for this batch. Save
                                  the timetable first, then enroll.
                                </div>
                              )}

                              <div className="d-flex flex-column gap-3">
                                {schedules.map((schedule, scheduleIndex) => {
                                  const sid = schedule.id;
                                  const entries = entriesBySchedule[sid] || [];
                                  const visibleEntries = isEnrollMode
                                    ? entries.filter(
                                      (entry) =>
                                        entry.id || !isEntryBlank(entry),
                                    )
                                    : entries;
                                  const isCollapsed = !!collapsed[sid];
                                  const selectedIds = selectedEnroll[sid] || [];
                                  const accent =
                                    ACCENTS[scheduleIndex % ACCENTS.length];
                                  const count = filledCount(sid);
                                  const savedIds = entries
                                    .filter((entry) => entry.id)
                                    .map((entry) => entry.id);
                                  const allScheduleSelected =
                                    savedIds.length > 0 &&
                                    savedIds.every((id) =>
                                      selectedIds.includes(id),
                                    );

                                  return (
                                    <div
                                      className="tt-schedule"
                                      id={`schedule-card-${sid}`}
                                      key={sid}
                                      style={{ "--tt-accent": accent }}
                                    >
                                      {/* Schedule header */}
                                      <div
                                        className="tt-schedule-header"
                                        onClick={() =>
                                          setCollapsed((prev) => ({
                                            ...prev,
                                            [sid]: !prev[sid],
                                          }))
                                        }
                                      >
                                        <div className="d-flex align-items-center gap-3">
                                          <span
                                            className="tt-step"
                                            style={{ background: accent }}
                                          >
                                            {scheduleIndex + 1}
                                          </span>
                                          <div>
                                            <div className="fw-semibold">
                                              {schedule.title}
                                            </div>
                                            <small className="text-muted">
                                              <i className="ri-time-line me-1"></i>
                                              {formatTime(schedule.start_time)}{" "}
                                              - {formatTime(schedule.end_time)}
                                            </small>
                                          </div>
                                        </div>

                                        <div className="d-flex align-items-center gap-2">
                                          {warnings[sid] && (
                                            <span className="badge bg-label-danger">
                                              <i className="ri-error-warning-line me-1"></i>
                                              Needs attention
                                            </span>
                                          )}
                                          {isEnrollMode &&
                                            selectedIds.length > 0 && (
                                              <span className="badge bg-success">
                                                {selectedIds.length} selected
                                              </span>
                                            )}
                                          <span
                                            className={`badge ${count > 0
                                              ? "bg-label-success"
                                              : "bg-label-secondary"
                                              }`}
                                          >
                                            {count > 0
                                              ? `${count} ${count === 1 ? "entry" : "entries"}`
                                              : "Empty"}
                                          </span>
                                          <i
                                            className={` ${isCollapsed ? "ri-arrow-down-s-line" : "ri-arrow-up-s-line"} text-muted`}
                                          />
                                        </div>
                                      </div>

                                      {!isCollapsed && (
                                        <div className="tt-schedule-body">
                                          {!isEnrollMode && warnings[sid] && (
                                            <div
                                              className="alert alert-warning py-2 mb-3"
                                              role="alert"
                                            >
                                              <i className="ri-alert-line me-2"></i>
                                              {warnings[sid]}
                                            </div>
                                          )}

                                          {isEnrollMode &&
                                            savedIds.length > 0 && (
                                              <div className="d-flex justify-content-end mb-2">
                                                <button
                                                  type="button"
                                                  className="tt-link-btn"
                                                  onClick={() =>
                                                    toggleScheduleEnroll(sid)
                                                  }
                                                >
                                                  {allScheduleSelected
                                                    ? "Unselect all in this schedule"
                                                    : "Select all in this schedule"}
                                                </button>
                                              </div>
                                            )}

                                          {visibleEntries.map(
                                            (entry, index) => {
                                              const isSelected =
                                                isEnrollMode &&
                                                selectedIds.includes(entry.id);
                                              const canSelect =
                                                isEnrollMode && !!entry.id;

                                              return (
                                                <div
                                                  className={`tt-entry ${isSelected ? "selected" : ""} ${canSelect ? "selectable" : ""}`}
                                                  key={entry.uid}
                                                  role={
                                                    canSelect
                                                      ? "checkbox"
                                                      : undefined
                                                  }
                                                  aria-checked={
                                                    canSelect
                                                      ? isSelected
                                                      : undefined
                                                  }
                                                  tabIndex={
                                                    canSelect ? 0 : undefined
                                                  }
                                                  onClick={
                                                    canSelect
                                                      ? () =>
                                                        toggleEnrollEntry(
                                                          sid,
                                                          entry.id,
                                                        )
                                                      : undefined
                                                  }
                                                  onKeyDown={
                                                    canSelect
                                                      ? (e) => {
                                                        if (
                                                          e.key === " " ||
                                                          e.key === "Enter"
                                                        ) {
                                                          e.preventDefault();
                                                          toggleEnrollEntry(
                                                            sid,
                                                            entry.id,
                                                          );
                                                        }
                                                      }
                                                      : undefined
                                                  }
                                                >
                                                  {isEnrollMode ? (
                                                    /* ---- Enroll mode: read-only summary ---- */
                                                    <div className="d-flex align-items-center gap-3 flex-wrap">
                                                      {entry.id ? (
                                                        <div className="form-check mb-0">
                                                          <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id={`enroll-entry-${entry.id}`}
                                                            checked={isSelected}
                                                            readOnly
                                                            tabIndex={-1}
                                                            style={{
                                                              pointerEvents:
                                                                "none",
                                                            }}
                                                          />
                                                        </div>
                                                      ) : (
                                                        <span className="badge bg-label-warning">
                                                          Not saved yet
                                                        </span>
                                                      )}

                                                      <span className="tt-entry-no">
                                                        {index + 1}
                                                      </span>

                                                      <div className="flex-grow-1">
                                                        <div className="fw-semibold">
                                                          {getSubjectName(
                                                            entry.subject_id,
                                                          )}
                                                        </div>
                                                        <small className="text-muted">
                                                          <i className="ri-user-line me-1"></i>
                                                          {getStaffName(
                                                            entry.teacher_id,
                                                          )}
                                                        </small>
                                                      </div>

                                                      <div className="d-flex flex-wrap gap-1">
                                                        {days
                                                          .filter((d) =>
                                                            entry.days.includes(
                                                              d,
                                                            ),
                                                          )
                                                          .map((d) => (
                                                            <span
                                                              className="tt-day-chip"
                                                              key={d}
                                                            >
                                                              {d}
                                                            </span>
                                                          ))}
                                                      </div>
                                                    </div>
                                                  ) : (
                                                    /* ---- Edit mode ---- */
                                                    <div className="row g-3 align-items-start">
                                                      <div className="col-lg-3 col-md-6">
                                                        <label className="tt-label">
                                                          <span className="tt-entry-no me-2">
                                                            {index + 1}
                                                          </span>
                                                          Subject
                                                        </label>
                                                        <select
                                                          className="form-select"
                                                          value={
                                                            entry.subject_id
                                                          }
                                                          onChange={(e) =>
                                                            updateEntry(
                                                              sid,
                                                              index,
                                                              "subject_id",
                                                              e.target.value,
                                                            )
                                                          }
                                                        >
                                                          <option value="">
                                                            Select Subject
                                                          </option>
                                                          {selectedBatch?.course?.subjects_data?.map(
                                                            (subject) => (
                                                              <option
                                                                key={subject.id}
                                                                value={
                                                                  subject.id
                                                                }
                                                              >
                                                                {subject.name ||
                                                                  subject.subject_name ||
                                                                  `Subject ${subject.id}`}
                                                              </option>
                                                            ),
                                                          )}
                                                        </select>
                                                      </div>

                                                      <div className="col-lg-3 col-md-6">
                                                        <label className="tt-label">
                                                          Teacher
                                                        </label>
                                                        <select
                                                          className="form-select"
                                                          value={
                                                            entry.teacher_id
                                                          }
                                                          onChange={(e) =>
                                                            updateEntry(
                                                              sid,
                                                              index,
                                                              "teacher_id",
                                                              e.target.value,
                                                            )
                                                          }
                                                        >
                                                          <option value="">
                                                            Select Teacher
                                                          </option>
                                                          {staffs.map(
                                                            (staff) => (
                                                              <option
                                                                key={staff.id}
                                                                value={staff.id}
                                                              >
                                                                {staff.name}
                                                              </option>
                                                            ),
                                                          )}
                                                        </select>
                                                      </div>

                                                      <div className="col-lg-5 col-md-10">
                                                        <div className="d-flex justify-content-between align-items-center">
                                                          <label className="tt-label mb-1">
                                                            Days
                                                          </label>
                                                          <span className="d-flex gap-2">
                                                            <button
                                                              type="button"
                                                              className="tt-link-btn"
                                                              onClick={() =>
                                                                updateEntry(
                                                                  sid,
                                                                  index,
                                                                  "days",
                                                                  [...WEEKDAYS],
                                                                )
                                                              }
                                                            >
                                                              Mon–Fri
                                                            </button>
                                                            <button
                                                              type="button"
                                                              className="tt-link-btn"
                                                              onClick={() =>
                                                                updateEntry(
                                                                  sid,
                                                                  index,
                                                                  "days",
                                                                  [],
                                                                )
                                                              }
                                                            >
                                                              Clear
                                                            </button>
                                                          </span>
                                                        </div>
                                                        <div className="d-flex flex-wrap gap-1">
                                                          {days.map((day) => {
                                                            const active =
                                                              entry.days.includes(
                                                                day,
                                                              );
                                                            return (
                                                              <button
                                                                type="button"
                                                                key={day}
                                                                id={`entry-${sid}-${entry.uid}-${day}`}
                                                                aria-pressed={
                                                                  active
                                                                }
                                                                className={`btn btn-sm tt-day ${active
                                                                  ? "btn-primary"
                                                                  : "btn-outline-secondary"
                                                                  }`}
                                                                onClick={() =>
                                                                  toggleEntryDay(
                                                                    sid,
                                                                    index,
                                                                    day,
                                                                  )
                                                                }
                                                              >
                                                                {day}
                                                              </button>
                                                            );
                                                          })}
                                                        </div>
                                                      </div>

                                                      <div className="col-lg-1 col-md-2 d-flex justify-content-end align-items-end pt-lg-4">
                                                        <button
                                                          type="button"
                                                          className="btn btn-sm btn-icon btn-label-danger"
                                                          title="Remove entry"
                                                          onClick={() =>
                                                            removeEntry(
                                                              sid,
                                                              index,
                                                            )
                                                          }
                                                        >
                                                          <i className="ri-delete-bin-line"></i>
                                                        </button>
                                                      </div>
                                                    </div>
                                                  )}
                                                </div>
                                              );
                                            },
                                          )}

                                          {visibleEntries.length === 0 && (
                                            <div className="tt-empty">
                                              <i className="ri-file-add-line fs-3 d-block mb-1"></i>
                                              {isEnrollMode
                                                ? "No entries in this schedule."
                                                : "No entries yet. Add a subject and teacher for this schedule."}
                                            </div>
                                          )}

                                          {!isEnrollMode && (
                                            <div className="d-flex flex-wrap gap-2">
                                              <button
                                                type="button"
                                                className="btn btn-sm btn-outline-primary"
                                                onClick={() => addEntry(sid)}
                                              >
                                                <i className="ri-add-circle-line me-2"></i>
                                                Add Subject / Teacher
                                              </button>

                                              {scheduleIndex > 0 && (
                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-label-secondary"
                                                  onClick={() =>
                                                    copyFromPrevious(
                                                      scheduleIndex,
                                                    )
                                                  }
                                                >
                                                  <i className="ri-file-copy-line me-2"></i>
                                                  Copy from previous schedule
                                                </button>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>

                              {/* ---------- Sticky action bar ---------- */}
                              {!isEnrollMode && (
                                <div className="tt-actionbar">
                                  <div className="text-muted small">
                                    <i className="ri-information-line me-1"></i>
                                    {totalEntries}{" "}
                                    {totalEntries === 1 ? "entry" : "entries"}{" "}
                                    across {filledSchedules} of{" "}
                                    {schedules.length} schedules. Empty
                                    schedules are skipped.
                                  </div>
                                  <button
                                    type="submit"
                                    className="btn btn-primary px-5"
                                    disabled={loading}
                                  >
                                    {loading ? (
                                      <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Saving...
                                      </>
                                    ) : (
                                      <>
                                        <i className="ri-checkbox-circle-line me-2"></i>
                                        Save All Schedules
                                      </>
                                    )}
                                  </button>
                                </div>
                              )}

                              {isEnrollMode && (
                                <div className="tt-actionbar">
                                  <div className="text-muted small">
                                    <i className="ri-login-box-line me-1"></i>
                                    {enrollHint}
                                  </div>
                                  <button
                                    type="button"
                                    className="btn btn-success px-5"
                                    disabled={
                                      enrollLoading ||
                                      totalSelected === 0 ||
                                      !newBatchId
                                    }
                                    onClick={handleEnroll}
                                  >
                                    {enrollLoading ? (
                                      <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Enrolling...
                                      </>
                                    ) : (
                                      <>
                                        <i className="ri-login-box-line me-2"></i>
                                        Enroll Selected
                                      </>
                                    )}
                                  </button>
                                </div>
                              )}
                            </>
                          )}
                        </form>
                      )}

                      {!batchId && (
                        <div className="text-center py-5">
                          <div className="tt-landing-icon">
                            <i className="ri-calendar-event-line"></i>
                          </div>
                          <h6 className="mt-3 mb-1">
                            Select a batch to get started
                          </h6>
                          <div className="text-muted small">
                            All schedules for the batch will appear here so you
                            can fill the whole timetable in one go.
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
